import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';

// Components
import ProductList from '../ProductList';
import Heading from '../Heading';
import AppLink from '../AppLink';
import Collapse from '../Collapse';

// Styles
import styles from './Catalog.styl';
import StyledHtml from '../StyledHtml';
import BlogMainPage from '../BlogMainPage';

const cx = classNames.bind(styles);

export default function Catalog(props) {
  const { className, isHiddenActions } = props;

  // при выборе категории каталог затухает и появляется
  const isHomeCatalogVisible = useSelector(state => state.ui.isHomeCatalogVisible);
  const { categories, list } = useSelector(state => state.catalog.products);
  const { title, content } = useSelector(state => state.city.userCity);

  const [isOpen, setIsOpened] = useState(false);

  const toggle = e => {
    e.preventDefault();
    setIsOpened(prev => !prev);
  };

  return (
    <div className={cx('Catalog', className, { Catalog_hidden: !isHomeCatalogVisible })}>
      {categories.map(category => (
        <ProductList
          key={category.id}
          category={category}
          list={list}
          isHiddenActions={isHiddenActions}
        />
      ))}
      {!isHiddenActions && <BlogMainPage />}
      {content && (
        <div className={cx('Catalog__seo', className, { Catalog__seo_opened: isOpen })}>
          <Heading className={cx('Catalog__seo-title')} level={1}>
            {title}
          </Heading>
          <div className={cx('Catalog__seo-content')}>
            <Collapse height={100} isOpen={isOpen}>
              <StyledHtml
                html={content}
                className={cx('Page__content')}
                dangerouslySetInnerHTML={{
                  __html: content,
                }}
              />
            </Collapse>
          </div>
          <AppLink className={cx('Catalog__seo-more')} href="#" onClick={toggle}>
            <FormattedMessage id={isOpen ? 'seo.text.rollUp' : 'seo.text.more'} />
          </AppLink>
        </div>
      )}

    </div>
  );
}

Catalog.defaultProps = {
  className: '',
  isHiddenActions: false,
};

Catalog.propTypes = {
  className: PropTypes.string,
  isHiddenActions: PropTypes.bool,
};
